<script>
import { required } from "vuelidate/lib/validators";
export default {
    data(){
        return {
            returnForm: {
                id: 0,
                remarks: "",
            },
            submitted: false,
        }
    },
    validations: {
        returnForm: { remarks: { required } },
    },
    methods: {
        returnData(item){
            this.returnForm.id = item.id;
            this.returnForm.remarks = "";
            this.$v.returnForm.$reset();
        },
        returnItemSubmit(){
            this.submitted = true;
            this.$v.returnForm.$touch();
            if (this.$v.returnForm.$invalid) {
                return;
            }
            this.$emit('returnItem', this.returnForm)
        }
    }
}
</script>
<template>
  <b-modal
        id="return-modal"
        title="Return Remarks"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="returnItemSubmit" class="needs-validation">
            <b-row>
                <b-col>
                    <div class="mb-3">
                        <label for="description">Remarks </label>
                        <textarea
                            id="description"
                            rows="3"
                            v-model="returnForm.remarks"
                            placeholder="Enter Remarks..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.returnForm.remarks.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.returnForm.remarks.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.returnForm.remarks.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Return Item
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('return-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>